import { render, staticRenderFns } from "./PurchasesMap.view.vue?vue&type=template&id=a6ccf0fe&"
import script from "./PurchasesMap.view.vue?vue&type=script&lang=js&"
export * from "./PurchasesMap.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ccf0fe')) {
      api.createRecord('a6ccf0fe', component.options)
    } else {
      api.reload('a6ccf0fe', component.options)
    }
    module.hot.accept("./PurchasesMap.view.vue?vue&type=template&id=a6ccf0fe&", function () {
      api.rerender('a6ccf0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/map/PurchasesMap.view.vue"
export default component.exports